/** Slovenian catalog — default UI language. Keys grow per phase. */
export const sl = {
  'app.title': 'Razpored redarjev',
  'auth.login.title': 'Prijava koordinatorja',
  'auth.login.emailLabel': 'E-poštni naslov',
  'auth.login.submit': 'Pošlji povezavo za prijavo',
  'auth.login.sent': 'Če je naslov na seznamu, smo poslali povezavo za prijavo.',
  'auth.login.invalidToken': 'Povezava ni veljavna ali je potekla. Zahtevaj novo.',
  'auth.logout': 'Odjava',
  'nav.pregled': 'Pregled',
  'nav.casovnica': 'Časovnica',
  'nav.predaje': 'Predaje',
  'nav.mesta': 'Mesta',
  'nav.prostovoljci': 'Prostovoljci',
  'nav.dnevnik': 'Dnevnik',
  'status.potrjen': 'potrjen',
  'status.caka': 'čaka',
  'status.zavrnjen': 'zavrnjen',
  'status.opravljeno': 'opravljeno',
  'error.generic': 'Prišlo je do napake. Poskusi znova.',
  'error.conflict': 'Podatek je medtem spremenil nekdo drug. Osveži in poskusi znova.',
  'error.boundary.title': 'Nekaj je šlo narobe.',
  'error.boundary.body': 'Napaka je zabeležena. Osveži stran; če se ponovi, sporoči koordinatorju.',
  'error.boundary.reload': 'Osveži stran',
  'error.boundary.requestId': 'Koda napake:',
} as const;

export type MessageKey = keyof typeof sl;
